var $e9243a5fd645a2cf$exports = {};
$e9243a5fd645a2cf$exports = {
  "backButton": args => "Terug naar ".concat(args.prevMenuButton),
  "moreActions": "Meer handelingen",
  "unavailable": "Niet beschikbaar, uitvouwen voor meer informatie"
};
export { $e9243a5fd645a2cf$exports as default };